module.exports = __webpack_public_path__ + "img/news.a10bb0b3.svg";